// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Partials
import { PartialsModule } from '../../../partials/partials.module';
// Pages
import { CoreModule } from '../../../../core/core.module';

import { MaterialModule } from '../../../pages/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { SelectInputComponent } from './select-input.component';

@NgModule({
	declarations: [
		SelectInputComponent
	],
	exports: [
		MaterialModule,
		PartialsModule,
		SelectInputComponent
	],
	imports: [
        PartialsModule,
        CoreModule,
        CommonModule,
        MaterialModule,
        TranslateModule.forChild(),
	],
	providers: []
})
export class SelectInputModule {
}